module.exports = __webpack_public_path__ + "img/plant_6_small.7667d92a.webp";